module.exports = __webpack_public_path__ + "media/images/regphonepic2-86bd6f35.svg";